import React, { useState, useEffect } from "react";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import { Navigate } from "react-router-dom";
import UseTitle from "../../components/useTitle";
import "./SpellTemplateNew.scss";

const SpellTemplateNew = () => {
  // Définition du titre de la page
  UseTitle("Création d'un sort");

  const [name, setName] = useState();
  const [domain, setDomain] = useState();
  const [range, setRange] = useState();
  const [duration, setDuration] = useState();
  const [catalyst, setCatalyst] = useState();
  const [cost, setCost] = useState(2);
  const [description, setDescription] = useState();
  const [valueStart, setValueStart] = useState(0);
  const [attributes, setAttributes] = useState([]);
  const [forBattle, setForBattle] = useState(false);
  const [isActiveDefault, setIsActiveDefault] = useState(true);

  const [allAttributes, setAllAttributes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [messageError, setMessageError] = useState([]);

  const [redirectTo, setRedirectTo] = useState();

  const checkSpellTemplate = () => {
    const errors = [];
    if (!name) errors.push("Veuillez renseigner le nom");
    if (!domain) errors.push("Veuillez renseigner le domaine");
    if (!range) errors.push("Veuillez renseigner la porte");
    if (!duration) errors.push("Veuillez renseigner la duree");

    const costNumber = Number(cost);
    if (cost === "" || isNaN(costNumber))
      errors.push("Veuillez renseigner le cout");
    else if (costNumber < 0)
      errors.push("Le cout doit être supérieur ou égal à 0");

    const valueStartNumber = Number(valueStart);
    if (valueStart === "" || isNaN(valueStartNumber))
      errors.push("Veuillez renseigner la valeur de base");
    else if (valueStartNumber < 0 || valueStartNumber > 50)
      errors.push("La valeur de base doit être comprise entre 0 et 50");

    if (attributes.length === 0)
      errors.push("Veuillez ajouter au moins un attribut");

    if (errors.length > 0) {
      setIsFormValid(false);
      setMessageError(errors);
    } else {
      setIsFormValid(true);
      setMessageError([]);
    }
  };

  const handleAttributeChange = (selectedAttribute) => {
    const attributeId = selectedAttribute.id;
    setAttributes((prevAttributes) =>
      prevAttributes.some((attribute) => attribute.id === attributeId)
        ? prevAttributes.filter((attribute) => attribute.id !== attributeId)
        : [...prevAttributes, selectedAttribute]
    );
  };

  const handleNew = () => {
    if (!isFormValid) return;

    setIsLoading(true);

    const attributeIds = attributes.map((attribute) => attribute.id);

    const spell_template_data = {
      name: name,
      domain: domain,
      range: range,
      duration: duration,
      catalyst: catalyst,
      pm: cost,
      description: description,
      attributes_ids: attributeIds,
      value_start: valueStart,
      for_battle: forBattle,
      is_active_default: isActiveDefault,
    };

    api
      .post(`/spelltemplate/`, spell_template_data)
      .then((response) => {
        setRedirectTo(`/spell/${response.data.id}`);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    api
      .get(`/attributes/`)
      .then((response) => {
        setAllAttributes(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    checkSpellTemplate();
  }, [name, domain, range, duration, cost, attributes, valueStart]);

  if (redirectTo) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return (
    <>
      <div className="spell-template-new">
        {isLoading && <p>Chargement...</p>}
        {!isLoading && (
          <>
            <h1>Nouveau sort</h1>
            <form
              className="spell-template-new-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleNew();
              }}
            >
              <div>
                <label htmlFor="name">Nom </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="domain">Domaine </label>
                <input
                  type="text"
                  name="domain"
                  id="domain"
                  value={domain}
                  onChange={(e) => setDomain(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="range">Portée </label>
                <input
                  type="text"
                  name="range"
                  id="range"
                  value={range}
                  onChange={(e) => setRange(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="duration">Durée </label>
                <input
                  type="text"
                  name="duration"
                  id="duration"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="catalyst">Catalyseur </label>
                <input
                  type="text"
                  name="catalyst"
                  id="catalyst"
                  value={catalyst}
                  onChange={(e) => setCatalyst(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="cost">Coût </label>
                <input
                  type="number"
                  name="cost"
                  id="cost"
                  value={cost}
                  min={0}
                  onChange={(e) => setCost(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="description">Description </label>
                <textarea
                  name="description"
                  id="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <div>
                <label>Attributs :</label>
                {allAttributes.map((attribute) => (
                  <div key={attribute.id}>
                    <input
                      type="checkbox"
                      name="attributes"
                      id={attribute.id}
                      checked={attributes.some(
                        (attributeToCheck) =>
                          attributeToCheck.id === attribute.id
                      )}
                      onChange={() => handleAttributeChange(attribute)}
                    />
                    <label htmlFor={attribute.id}>{attribute.full_name}</label>
                  </div>
                ))}
              </div>
              <div>
                <label htmlFor="valueStart">Valeur de départ </label>
                <input
                  type="number"
                  name="valueStart"
                  id="valueStart"
                  value={valueStart}
                  min={0}
                  max={50}
                  onChange={(e) => setValueStart(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="forBattle">Pour la bataille </label>
                <input
                  type="checkbox"
                  name="forBattle"
                  id="forBattle"
                  checked={forBattle}
                  onChange={(e) => setForBattle(e.target.checked)}
                />
              </div>
              <div>
                <label htmlFor="isActiveDefault">Est actif par defaut </label>
                <input
                  type="checkbox"
                  name="isActiveDefault"
                  id="isActiveDefault"
                  checked={isActiveDefault}
                  onChange={(e) => setIsActiveDefault(e.target.checked)}
                />
              </div>
              <div className="buttons">
                <button
                  className={!isFormValid ? "bt disabled" : "bt"}
                  type="submit"
                  disabled={!isFormValid}
                >
                  Valider
                </button>
                <button
                  className="bt"
                  type="button"
                  onClick={() => setRedirectTo("/spell/")}
                >
                  Annuler
                </button>
              </div>
            </form>
            {messageError.length > 0 && (
              <div className="errors">
                {messageError.map((messageError, index) => (
                  <p className="error" key={index}>
                    {messageError}
                  </p>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default SpellTemplateNew;
